<template>
  <div class="drugInfo" v-if="showPage">
    <!-- 图片 -->
    <!-- <div class="drugInfo-status">
        <div class="status-img">
          <img src="/static/drugInfo/passed.png" width="200" alt="" />
        </div>
        <div class="status-text">审核通过</div>
        <div class="status-notice">请按照下方信息带好领药材料按时领药</div>
    </div> -->

    <!-- 提示 -->
    <div class="upload-status" v-if="showNotice">
      <div class="status">
        <img width="16px" style="margin-right:3px;" src="/static/upload/refuseIcon.png" />
        <div>若您已邮寄到项目办，则无需提供给药房</div>
      </div>
    </div>

    <div class="appointment-list-1" v-if="items.length > 0">
      <van-cell-group :border="false">
        <template #title>
          <span class="custom-title">{{ text1 }}</span>
        </template>
        <van-cell v-for="(item, index) in items" :key="index" :border="false" style="min-height: 75px;">
          <template #title>
            <span class="custom-title">
              <div style="font-size:15px;">{{ item.name }}</div>
              <div style="color:#9D9D9D;">{{ item.remark }}</div>
            </span>
          </template>
          <div v-if="item.name != '身份证原件' && item.image_url" style="width:100%;display:flex;justify-content:center;" @click="showPic([{ filepath: item.image_url }])">
            <img src="/static/checkoutImg.png" width="55px" height="55px" />
          </div>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="appointment-list-2">
      <van-cell-group :border="false">
        <template #title>
          <span class="custom-title">{{ text2 }}</span>
        </template>

        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">患者姓名：</div>
            <div>{{ patient_name }}</div>
          </div>
        </van-cell>
        <!-- <van-cell :border="false">   
           <div style="color:#9D9D9D;white-space:nowrap;">援助方式：</div>   <div>{{mode_type}}</div> 
        </van-cell> -->
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">当前轮次、周期：</div>
            <div>第{{ rounds }}轮次 第{{ rounds_phase }}周期</div>
          </div>
        </van-cell>
        <div v-for="(item, index) in receiveInfo.drugs" :key="index">
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">药品名称：</div>
              <div>{{ item.drug_name }}</div>
            </div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">药品规格：</div>
              <div>{{ item.specifications }}</div>
            </div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">药品数量：</div>
              <div>{{ item.pre_quantity }}</div>
            </div>
          </van-cell>
        </div>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">项目药房：</div>
            <div>{{ drugstore }}</div>
          </div>
        </van-cell>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">药房地址：</div>
            <div>{{ drugstore_address }}</div>
          </div>
        </van-cell>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">药房联系方式：</div>
            <div>{{ drugstore_phone }}</div>
          </div>
        </van-cell>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">公益专员联系方式：</div>
            <div v-if="volunteer_name" style="word-break:normal;">{{ volunteer_name }}/ {{ volunteer_phone }}</div>
            <div v-else style="word-break:normal;">暂无</div>
          </div>
        </van-cell>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">领药时间：</div>
            <div>{{ receiveInfo.pre_receive_date }}</div>
          </div>
        </van-cell>
        <van-cell :border="false">
          <div class="alignment-flex">
            <div style="color:#9D9D9D;white-space:nowrap;">领药人角色：</div>
            <div>{{ name }}</div>
          </div>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="btn" v-if="!isLoading">
      <van-button type="default" class="up " @click="goBack" :disabled="disabled" color="#0AA8AF">{{ btntxt }}</van-button>
      <!-- <van-button v-if="active != 0" type="default" class="back" @click="toPrev()">上一步</van-button> -->
    </div>
  </div>
</template>
<script>
import { GetPatient, CheckItemStatus, GetCheckItem, UploadPatientStatus, GetReceiveInfo, getShowItem } from '../../api/api'
import { getAgentApply, getCheckItems } from '@/api/patient'

import Vue from 'vue'
import { mapState } from 'vuex'
import { Toast, Notify, ImagePreview } from 'vant'

Vue.use(ImagePreview)
Vue.use(Toast)
export default {
  data() {
    return {
      text1: '本人领药需要携带材料原件',
      text2: '领药信息',
      btntxt: '返回首页',
      disabled: false,
      isLoading: false,
      receiveInfo: null,

      patient_name: '',
      mode_type: '',
      rounds: '1',
      rounds_phase: '1',
      drugstore: '',
      drugstore_address: '',
      drugstore_phone: '',
      volunteer_phone: '',
      volunteer_name: '',
      name: '',

      items: [],
      showPage: false,
      src: [],

      showNotice: true, //显示顶部提示

      agentApply: null //代领人对象
    }
  },
  async created() {
    Toast.clear()
    await this.getData()
    this.showPage = true
  },
  computed: {
    ...mapState(['patientOne', 'userInfo', 'patientInfo'])
  },
  methods: {
    async getData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })
      // let res = await GetPatient({
      //   papid: this.patientOne.papid
      // })
      let res = { data: this.patientInfo }
      const { patient, drugstore, phase, predict, volunteer, mode_name, rounds_phase } = res.data
      console.log(res.data)
      this.patient_name = patient.name
      this.mode_type = mode_name
      this.rounds = patient.rounds
      this.rounds_phase = rounds_phase
      this.drugstore = drugstore.name
      this.drugstore_address = drugstore.address
      this.drugstore_phone = drugstore.druggist_phone
      this.volunteer_phone = volunteer.mobile
      this.volunteer_name = volunteer.name

      let re_info = await GetReceiveInfo({
        papid: this.patientOne.papid
      })
      this.receiveInfo = re_info.data
      this.name = this.receiveInfo.agent_name
      console.log('receiveInfo', re_info.data)

      await getShowItem({ papid: this.userInfo.patient.papid }).then(res => {
        console.log('getShowItem-res', res.data)
        this.items = res.data
      })

      //领药人领药
      if (this.name != '本人') {
        this.name = '代领药人领药'
        this.text1 = '代领药人领药需要携带的材料'
        await getAgentApply({ papid: this.patientOne.papid }).then(res => {
          if (res.data) {
            this.agentApply = res.data
            console.log('代领人对象', this.agentApply)
          }
        })
        this.name = this.agentApply ? '代领药人领药' : '本人'
        if (this.agentApply) {
          await getCheckItems({
            papid: this.patientOne.papid,
            category: '代领人领药审核'
            // phase: res.data.patient.receive_phase
          }).then(res => {
            console.log('代领人材料', res.data[0].data)
            let items = [...this.items, ...res.data[0].data]
            console.log('代领人领药全部材料', this.items)
            let temp = []
            items.forEach(ele => {
              if (ele.name != '患者本人身份证照片') {
                // ele.name='本人、代领人身份证'
                temp.push(ele)
              }
            })
            this.items = temp
          })
        }
      }
      Toast.clear()
    },
    showPic(route, index) {
      this.src = []
      if (route[0].filepath == '') return
      if (Array.isArray(route)) {
        route.forEach(ele => {
          this.src.push(ele.filepath)
        })
      } else {
        this.src.push(route)
      }
      this.$nextTick(() => {
        ImagePreview({
          images: this.src,
          showIndex: true,
          loop: false,
          startPosition: index ? index : 0
        })
      })
    },
    //下一步
    goBack() {
      this.$router.push({ name: 'Timeline' })
    }
  }
}
</script>

<style lang="less">
.drugInfo {
  height: 100%;
  // min-height: 100vh;
  width: 100%;
  // margin-bottom: 50px;
  box-sizing: border-box;

  .upload-status {
    box-sizing: border-box;
    padding: 10px 15px;
    margin: 16px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #ffdadb;
    font-size: 14px;
    color: #ff4830;
    .status {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-start;
      img {
        margin-top: 2px;
      }
    }
    &.red {
      color: @red;
    }
  }
  .drugInfo-status {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .status-text {
      margin-top: -20px;
      font-weight: 500;
      font-size: 16px;
    }
    .status-notice {
      font-size: 14px;
      margin: 10px 0;
      color: #00000062;
    }
  }
  .appointment-list-1,
  .appointment-list-2 {
    box-sizing: border-box;
    margin: 16px;
    border-radius: 10px;
    box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0);
    overflow: hidden;
    .van-cell__value {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .alignment-flex {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }
    .appointment-status {
      box-sizing: border-box;
      //   padding: 10px 15px;
      //   margin: 16px;
      border-radius: 10px;
      overflow: hidden;
      //   background-color: #FFDADB;
      font-size: 14px;
      color: #ff4830;
      .img-status {
        display: flex;
        align-items: center;
      }
      &.red {
        color: @red;
      }
    }
  }
  .van-cell__title {
    flex: 3 2;
  }
  .appointment-list-1 .van-cell-group__title {
    background: #ffb253;
  }
  .appointment-list-2 .van-cell-group__title {
    background: #0aa8af;
  }
  .van-cell-group__title {
    color: #fff;
    padding: 10px;
    .custom-title {
      margin-left: 10px;
    }
    &::after {
      content: '';
      width: 4px;
      height: 15px;
      background-color: #e8f4a6;
      position: absolute;
      left: 25px;
      border-radius: 2px;
    }
  }
}

.van-overlay {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
